import { getImageSrc } from "@authentic/loyalty-pwa/util"
import { FunctionalComponent, h } from "preact"
import { Points } from "../points/points"
import { TierPoints } from "../tier-points/tier-points"
import { DetailStyled, ImageStyled, TierInfoStyled } from "./tier-info.styled"

export interface TierInfoDetailProps {
  points?: {
    number: string,
    pointsLabel: string,
    currency: string
  },
  imageName?: string,
  description: string
}

export interface TierInfoProps {
  tierPoints: {
    title: string,
    subtitle?: string,
    color: string,
    image: h.JSX.Element
  },
  detail: TierInfoDetailProps[]
}
export const TierInfo: FunctionalComponent<TierInfoProps> = ({ tierPoints, detail }) => {
  return (
    <TierInfoStyled className="tier-info">
      <TierPoints
        title={tierPoints.title}
        subtitle={tierPoints.subtitle}
        color={tierPoints.color}
        image={tierPoints.image}></TierPoints>

      <DetailStyled>
        {detail?.map((item: TierInfoDetailProps) => (
          <li>
            {item.points && (
              <Points
                number={item.points.number}
                pointsLabel={item.points.pointsLabel}
                color={tierPoints.color}
                currency={item.points.currency}
              ></Points>
            )}

            {item.imageName && (
              <ImageStyled>
                <img src={getImageSrc(require('../../assets/' + item.imageName).default)} alt="" />
              </ImageStyled>
            )}
            <p>{item.description}</p>
          </li>
        ))}
      </DetailStyled>
    </TierInfoStyled>
  )
}